<template>
    <section>
        <div class="custom-input-group">
            <div>
                <span>{{ payload.description.label }}</span>
                <span v-if="payload.description.required" class="required-field-indicator" title="Campo obrigatório">*</span>
            </div>
            <textarea class="form-control" rows="6" placeholder="Descreva sua solicitação..." v-model="payload.description.value"></textarea>
        </div>
        <div class="buttons-container">
            <button class="form-control" id="cancel-button" @click="cancel"><i class="fas fa-times"></i>  Descartar</button>
            <button v-if="!saving" class="form-control" id="save-button" @click="save"><i class="fas fa-save"></i>  Salvar</button>
            <button v-else class="form-control" id="save-button" disabled><i class="fas fa-spinner fa-pulse"></i>  Salvando...</button>
        </div>
    </section>
</template>

<script>
export default {
    directives: {},
    props: ['clientInfo', 'saveLoading', 'reset'],
    components: {},
    data() {
        return {
            saving: false,
            payload: {
                description: {label: 'Descrição', value: '', required: true},
            }
        }
    },
    methods: {
        async save() {
            this.$emit('save', {type: 'outros', data: this.payload})
        },
        async cancel() {
            Swal.fire({
                title: 'Descartar solicitação?',
                html: 'Deseja descartar as alterações feitas?',
                showCancelButton: true,
                confirmButtonText: 'Sim, descartar',
                cancelButtonText: 'Não, continuar editando',
                type: "question",
                showCloseButton: true,
                reverseButtons: true
            }).then(async result => {
                if(result.value) {
                    this.$emit('cancel')
                    await this.resetForm()
                }
            });
        },
        async resetForm() {
            this.payload = {
                description: {label: 'Descrição', value: '', required: true},
            }
        },
    },
    watch: {        
        saveLoading: {
            handler(value) {
                this.saving = value
            }
        },
        reset() {
            this.resetForm()
        }
    }
}
</script>

<style lang="scss" scoped>
.required-field-indicator {
    font-size: small;
    text-align: start;
    color: red;
}
.custom-input-group {
    display: flex;
    flex-direction: column;
    text-align: start;
    width: 100%;
    justify-content: center;

    span {
        font-weight: bold;
    }

    textarea {
        resize: none
    }

    .input-with-button {
        display: flex;
        gap: 5px;
        height: 100%;
        align-items: center;

        button {
            border-radius: 10px !important;
            box-shadow: none;
        }
    }
}

.buttons-container {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
    margin-bottom: 0;
    margin-top: 10px;

    button {
        width: fit-content;
        color: white;
        border-radius: 10px !important;
        box-shadow: none;
        transition: ease-in-out 0.2s
    }

    #save-button {
        background-color: darkgreen;

        &:hover {
            background-color: #023b02;
        }
    }

    #cancel-button {
        background-color: #a00404;

        &:hover {
            background-color: #6d0303;
        }
    }
}

.solicitation-info {
    display: flex;
    gap: 10px;
    min-height: 70px;

    input {
        cursor: pointer;
    }
}
</style>